'use strict';
var base = require('./base');

module.exports = {
    availability: base.availability,
    updateQuantityEvent: base.updateQuantityEvent,
    expandImage: base.expandImage,
    addClassSelectedThumb: base.addClassSelectedThumb,
    detailsAccordionTrigger: base.detailsAccordionTrigger,

    addToCart: base.addToCart,

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            $('button.add-to-cart-global').attr('disabled', !enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }

            $('.row--quantity').toggleClass('storeExclusive', response.product.isStoreExclusive);

            var $stockLabelContainer = $('.stock-label-container', response.$productContainer);

            if ($stockLabelContainer) {
                var $stockLabel = $('.stock-label', $stockLabelContainer);
                var $stockMessage = $('.stock-message', $stockLabelContainer);

                // Remove existing color classes
                $stockLabel.removeClass('red yellow green');

                var inventory = response.product?.inventory || false;

                if (inventory.message.length > 0) {
                    $stockMessage.html(inventory.message);
                    $stockLabel.addClass(inventory.indicator);
                } else {
                    $stockMessage.html($stockLabelContainer.data('default-message'));
                    $stockLabel.addClass($stockLabelContainer.data('default-indicator'));
                }

                if (!response.product.isStoreExclusive) {
                    $stockLabelContainer.show();
                } else {
                    $stockLabelContainer.hide();
                }
            }

            var $backInStockButton = $('#backInStock-btn');
            if ($backInStockButton.length) {
                var $backinstockPid = $('#backinstock-pid');
                $backinstockPid.val(response.product.id);

                var isAllSelected = response.product.variationAttributes.every(attribute => {
                    if (!attribute.values || attribute.values.length === 0) {
                        return true; // Attribute has no values, consider it selected
                    }
                    return attribute.values.filter(value => value.selected).length > 0;
                });

                if (isAllSelected && !response.product.isStoreExclusive && (!response.product.available || !response.product.readyToOrder)) {
                    $backInStockButton.removeClass('d-none');
                } else {
                    $backInStockButton.addClass('d-none');
                }
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },
    scrollToBottom: function () {
        if ($('.row--quantity').hasClass('storeExclusive') === false) {
            var stickyBtn = document.getElementsByClassName('row--quantity')[0];

            $('.availability.product-availability').length > 0 && $('.row--quantity').css('bottom', '29px');

            window.onscroll = function() {
                // Base product could be NOT store exclusive, but variation could be store exclusive
                if ($('.row--quantity').hasClass('storeExclusive') === false) {
                    if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight - stickyBtn.clientHeight) {
                        $('.row--quantity, .availability.product-availability').stop().fadeOut();
                    } else {
                        $('.row--quantity, .availability.product-availability').stop().fadeIn(250);
                    }
                }
            };
        }
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal()
};
